module.exports = __webpack_public_path__ + "img/ordF2.cfecdbe9.jpg";